// extracted by mini-css-extract-plugin
export default {"tabGroup":"TopUpPanel_tabGroup","tabList":"TopUpPanel_tabList","tab":"TopUpPanel_tab","panels":"TopUpPanel_panels","interestOnlyContainer":"TopUpPanel_interestOnlyContainer"};